<template>
  <div class="real_time_flow">
    <div class="top_bar">
      <span class="title_nbhd">实时流量<span> - {{ name }}</span></span>
      <span class="go_back" @click="goBack">返回</span>
    </div>
    <div class="ad_stat">
      <DataIncrease class="increase" ref="increase1" :start-val="totalNum1" :end-val="totalNum2" :add-val="addNum"></DataIncrease>
      <DataIncrease class="increase" ref="increase2" :start-val="reachNum1" :end-val="reachNum2" :add-val="addReach" text="今日广告触达次数"></DataIncrease>
      <DataIncrease class="increase" ref="increase3" :timeType="true" :start-val="playTimes1" :end-val="playTimes2" :add-val="addTime" text="今日广告触达时长"></DataIncrease>
    </div>
    <div class="data_insight">
      <div class="data_box">
        <div class="data_title">
          <span style="margin-right: 10px;">实时数据</span>
          <el-switch
            v-model="update"
            active-color="#FF3973">
          </el-switch>
        </div>
        <template v-if="noMore">
          <div class="chart">
            <DynBar
            :barConfig="barConfig" :id="nbhdGuid" :update="update"
            @clickBar="onBarClick" @changeShowTime="data => time = data"
          ></DynBar>
          </div>
          <div class="right_box">
            <DataShow :list="list" :time="time" :update="update"></DataShow>
          </div>
        </template>
        <div v-else class="no_data">
          暂无数据，<span class="refresh_btn" @click="refreshData">立即刷新</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DataShow from "./components/DataShow";
import DynBar from "./components/DynBar";
import DataIncrease from "./components/DataIncrease";
const _map = {}
export default {
  name: "BytesInsight",
  props: [ 'id', 'name' ],
  components: { DataShow, DataIncrease, DynBar },
  data () {
    let nbhdGuid = this.id
    return {
      // 点击图表后接受该时间段详细信息数组
      list: [],
      time: 0,
      totalNum1: 0,
      totalNum2: 0,
      addNum: 0,
      reachNum1: 0,
      reachNum2: 0,
      addReach: 0,
      playTimes1: 0,
      playTimes2: 0,
      addTime: 0,
      noMore: true,
      update: true,
      nbhdGuid,
      // 存放为返回数据的时间戳
      timeArr: [],
      // 15s增加的数据
      barConfig: { x: [], y: [] },
      inter: null
    }
  },
  watch: {
    update (v) {
      if (v) {
        this.startPolling()
      }
    }
  },
  mounted() {
    this.startPolling()
  },
  beforeDestroy () {
    if (this.inter) {
      clearInterval(this.inter)
      this.inter = null
    }
  },
  methods: {
    startPolling () {
      this.gainFirst() // 全量请求
    },
    /**
     * 获取特定时刻的流量详情数据,同时关闭【实时数据】开关
     * @param {Number} stamp 以秒为单位的时间戳(10位,格式化转换时需乘以1000)
     */
    onBarClick (stamp) {
      this.list = [] // 清空上一时刻的流量抓图数据
      this.getDetail(stamp)
      this.update = false
    },
    // 刷新页面
    refreshData () {
      this.startPolling()
    },
    // 返回（不刷新原页面）
    goBack () {
      this.$emit('back')
    },
    // 获取整除15秒的时间
    format () {
      let now = Date.parse(new Date())
      let t = now - now % 15000
      return t/1000 - 60 // -60请求一分钟之前的数据
    },
    handleErrorCode (res) {
      this.messageTip(res.msg || '请求失败')
      if (this.inter) {
        clearInterval(this.inter)
        this.inter = null
      }
      this.$emit('back')
    },
    async gainFirst () {
      let time = this.format()
      this.getDetail(time) // 首次加载当前刚刚数据
      let res = await this.fetch(`/flow-analytics/stats/${this.nbhdGuid}`, { time }, 'get')
      if (res && res.code === 900702) {
        return this.handleErrorCode(res)
      }
      if (res && res.code === 0 && res.data) {
        let resList = res.data.resultList || []
        this.totalNum2 = res.data.totalNum
        this.reachNum2 = res.data.reachNum
        this.playTimes2 = res.data.playTimes
        this.$refs.increase1.getFirst(this.totalNum2)
        this.$refs.increase2.getFirst(this.reachNum2)
        this.$refs.increase3.getFirst(this.playTimes2)
        resList.forEach(el => {
          _map[el.time] = el.num
        })
        this.noMore = true
        this.interFn() // 开始启动实时定时器
      } else {
        _map = {}
        if (this.inter) clearInterval(this.inter)
        this.noMore = false
      }
      this.$nextTick(() => {
        this.handleBarConfig()
      })
    },
    interFn () {
      this.$refs.increase1.timeChange()
      this.$refs.increase2.timeChange()
      this.$refs.increase3.timeChange()
      if (this.inter) clearInterval(this.inter)
      this.inter = setInterval(() => {
        this.getList() // 请求数据
        this.$refs.increase1.timeChange()
        this.$refs.increase2.timeChange()
        this.$refs.increase3.timeChange()
      }, 15000)
    },
    handleBarConfig () {
      this.barConfig = { // 改变 barConfig 触发柱状图变化
        x: Object.keys(_map), y: Object.values(_map)
      }
    },
    handleConcat (res) {
      if (res && res.code === 0 && res.data) {
        ;(res.data || []).forEach(el => {
          _map[el.time] = el.num
        })
      }
      this.handleBarConfig()
    },
    async getDetail (time) {
      let res = await this.fetch(`/flow-analytics/stats/v2/interval/${this.nbhdGuid}`, { times: [time] }, 'get')
      if (res && res.code === 0) {
        this.list = res.data[0].resList
      }
    },
    // 每15秒获取一次实时流量数据
    async getList () {
      let time = this.format()
      this.timeArr.push(time)
      // 获取实时流量接口去除loading方便用户操作 lzd-20240104
      const api = `/flow-analytics/stats/v2/interval/${this.nbhdGuid}`
      const param = { times: [...new Set(this.timeArr)] }
      let res = await this.fetch(api, param, 'get', {}, undefined, true)
      if (res && res.code === 900702) {
        return this.handleErrorCode(res)
      }
      if (res && res.code === 0) {
        let i = res.data.length
        // 处理叠加数据
        this.addNum = 0
        this.addReach = 0
        this.addTime = 0
        for (let j = 0; j < i; j++) {
          this.addNum += res.data[j].num
          this.addReach += res.data[j].reachNum
          this.addTime += res.data[j].playTimes
        }
        this.totalNum1 = this.totalNum2
        this.totalNum2 +=  this.addNum
        this.reachNum1 = this.reachNum2
        this.reachNum2 +=  this.addReach
        this.playTimes1 = this.playTimes2
        this.playTimes2 +=  this.addTime
        console.log(this.totalNum1, this.totalNum2, 'total')
        // 处理右侧详细信息,需实时状态下
        if (this.update) this.list = res.data[i-1].resList
        // 清空数据异常的时间戳
        this.timeArr = []
      }
      this.handleConcat(res)
    }
  }
}
</script>

<style lang="scss" scoped>
  .real_time_flow {
    height: 100%;
    .top_bar {
      height: 65px;
      padding: 0 20px;
      border-bottom: 1px solid #E9E9E9;
      .title_nbhd {
        height: 65px;
        line-height: 65px;
        color: #282729;
        font-size: 18px;
        font-weight: 600;
        span {
          color: #999;
        }
      }
      .go_back {
        width: 100px;
        height: 30px;
        line-height: 30px;
        margin-top: 20px;
        text-align: center;
        color: #FF3973;
        float: right;
        border: 1px solid #FF3973;
        border-radius: 4px;
        cursor: pointer;
      }
    }
    .ad_stat {
      height: 120px;
      border-bottom: 1px solid #E9E9E9;
      .increase {
        width: 33%;
        height: 100%;
        float: left;
        border-right: 1px solid #E9E9E9;
      }
    }
  }
  .data_insight {
    height: calc(100% - 185px);
    padding: 20px;
    .data_box {
      height: 100%;
      border: 1px solid #E9E9E9;
      border-radius: 4px;
      .no_data {
        height: calc(100% - 40px);
        display: flex;
        justify-content: center;
        align-items: center;
        font-size:14px;
        font-family:PingFangSC-Regular,PingFang SC;
        font-weight:400;
        color:rgba(153,153,153,1);
        .refresh_btn {
          color: #FF3973;
          cursor: pointer;
        }
      }
      .data_title {
        height: 40px;
        line-height: 40px;
        padding-left: 20px;
        color: #282729;
        border-bottom: 1px solid #E9E9E9;
        font-size: 14px;
        font-weight: 500;
        background:rgba(245,245,245,1);
      }
      .chart {
        float: left;
        width: calc(100% - 240px);
        height: calc(100% - 40px);
      }
      .right_box {
        float: left;
        width: 240px;
        height: calc(100% - 40px);
        border-left: 1px solid #E9E9E9;
      }
    }
  }
</style>
